var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00345 1.94584L2.77558 2.65813C1.78739 3.23137 1.29329 3.518 1.02164 3.99483C0.75 4.47165 0.75 5.05233 0.75 6.21368V14.3783C0.75 15.9042 0.75 16.6672 1.09226 17.0918C1.32001 17.3744 1.63916 17.5643 1.992 17.6273C2.52226 17.7219 3.17148 17.3453 4.46987 16.5921C5.35156 16.0806 6.20011 15.5494 7.25487 15.6935C7.73466 15.759 8.19231 15.9866 9.1076 16.4417L12.9215 18.338C13.7464 18.7482 13.754 18.75 14.6714 18.75H16.75C18.6356 18.75 19.5784 18.75 20.1642 18.1513C20.75 17.5526 20.75 16.5889 20.75 14.6617V7.92148C20.75 5.99423 20.75 5.0306 20.1642 4.43188C19.5784 3.83316 18.6356 3.83316 16.75 3.83316H14.6714C13.754 3.83316 13.7464 3.83139 12.9215 3.4212L9.58987 1.76463C8.19884 1.07297 7.50332 0.727138 6.76238 0.751172C6.02143 0.775206 5.34877 1.16542 4.00345 1.94584Z",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0.75L6.75 15.25",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.25L13.75 18.25",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapActive);
export default __webpack_public_path__ + "static/media/map-active.4f4451c416a4e135d709db9635ab0337.svg";
export { ForwardRef as ReactComponent };